// extracted by mini-css-extract-plugin
export default {"cardDisabled":"styles_cardDisabled__VlF3Z"};